import { create } from 'zustand';

// Persist the sidebar collapsed state so a collapsed rail survives reloads.
const STORAGE_KEY = 'fv.sidebarCollapsed';

function readInitial(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function persist(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    // ignore storage failures (private mode / quota) — state still works in-memory
  }
}

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: readInitial(),
  toggleSidebar: () =>
    set((s) => {
      const next = !s.sidebarCollapsed;
      persist(next);
      return { sidebarCollapsed: next };
    }),
  setSidebarCollapsed: (collapsed) => {
    persist(collapsed);
    set({ sidebarCollapsed: collapsed });
  },
}));
